import { FC, memo, PropsWithChildren } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { useRootDocument } from '~/core/shared/hooks';
import {
  Evaluatable,
  WorkflowDataResolverDependencies,
} from '~/core/shared/types';
import { resolveEvaluatable } from '~/core/shared/utils/evaluatable';
import { evaluate } from '~/core/shared/utils/general';

type DisplayWhenProps = PropsWithChildren<{
  evaluatable: Evaluatable;
  workflowDataResolverDependencies: Partial<WorkflowDataResolverDependencies>;
}>;

const DisplayWhenComponent: FC<DisplayWhenProps> = ({
  evaluatable,
  workflowDataResolverDependencies,
  children,
}) => {
  const { control, getValues } = useFormContext();
  useWatch({ control });
  const rootDocument = useRootDocument();
  const resolvedEvaluatable = resolveEvaluatable(
    evaluatable,
    {
      rootDocument,
      getFormValue: getValues,
      ...workflowDataResolverDependencies,
    },
    getValues,
  );
  const isDisplaying = evaluate(resolvedEvaluatable);

  return <>{isDisplaying && children}</>;
};

export const DisplayWhen = memo(DisplayWhenComponent);
